import(/* webpackMode: "eager" */ "/workspace/src/app/page.tsx");
